import { useSelector } from 'react-redux';
import { getTags } from '../../authSlice/authSelectors';

function useGetTags(): string[] {
  return useSelector(getTags);
}

export default useGetTags;
